import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { CreateProduct } from 'app/dtos/Product/createProduct';
import { UpdateProduct } from 'app/dtos/Product/updateProductService';
import { CreateProducts } from 'app/dtos/Product/createProducts';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllProducts(page, size, search, brandModelId?: number, brandId?: number, unitTypeId?: number, categoryId?: number, currencyId?: number, warehouseId?: number, kindId?: number): Promise<any> {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Product,
      queryString: `Page=${page}&Size=${size}&Search=${search}&brandModelId=${brandModelId}&brandId=${brandId}&unitTypeId=${unitTypeId}&categoryId=${categoryId}&currencyId=${currencyId}&warehouseId=${warehouseId}&kindId=${kindId}`
    });
    return await firstValueFrom(observable);
  }
  async getByIdProduct(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Product
    }, id);
    return await firstValueFrom(observable);
  }

  async createProduct(createProduct: CreateProduct) {
    console.log(this.createProduct);

    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Product
    }, {
      code: createProduct.code,
      name: createProduct.name,
      productType: createProduct.productType,
      unitTypeId: createProduct.unitTypeId,
      currencyId: createProduct.currencyId,
      purchasePrice: createProduct.purchasePrice,
      salePrice: createProduct.salePrice,
      purchaseTaxId: createProduct.purchaseTaxId,
      saleTaxId: createProduct.saleTaxId,
      categoryId: createProduct.categoryId,
      barcode: createProduct.barcode,
      criticalStock: createProduct.criticalStock,
      labels: createProduct.labels,
      connectedSubProductId: createProduct.connectedSubProductId,
      subProductCount: createProduct.subProductCount,
      serialNo: createProduct.serialNo,
      brandModelId: createProduct.brandModalId,
      kindId: createProduct.kindId,
      createProductVaryantDtos:createProduct.createProductVaryantDtos
    });
    return await firstValueFrom(observable);
  }

  async updateProduct(updateProduct: UpdateProduct) {

    console.log(updateProduct);
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Product
    }, {
      id: updateProduct.id,
      code: updateProduct.code,
      name: updateProduct.name,
      productType: updateProduct.productType,
      unitTypeId: updateProduct.unitTypeId,
      currencyId: updateProduct.currencyId,
      purchasePrice: updateProduct.purchasePrice,
      salePrice: updateProduct.salePrice,
      purchaseTaxId: updateProduct.purchaseTaxId,
      saleTaxId: updateProduct.saleTaxId,
      categoryId: updateProduct.categoryId,
      barcode: updateProduct.barcode,
      criticalStock: updateProduct.criticalStock,
      labels: updateProduct.labels,
      brandModelId: updateProduct.brandModelId,
      kindId: updateProduct.kindId,
      updateProductVaryantDtos: updateProduct.updateProductVaryantDtos
    });
    return await firstValueFrom(observable);
  }

  async createProducts(createProduct: CreateProducts[]) {
    console.log(createProduct);
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Product,
      action: "CreateProducts"
    }, createProduct);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
